import { SharpServiceNames } from '../interfaces/client-manager.interface';

export type SharpProviderResponse = SharpProviderIncidentResponse[];

/**
 * Response from POST v1/create-sharp-ticket since ticket creation was decoupled onto a
 * queue (SHP-9342): the request is only accepted/queued, not created synchronously, so
 * the endpoint no longer forwards Sharp's own SharpProviderResponse array.
 */
export interface SharpTicketAcceptedResponse {
    accepted: boolean;
    message: string;
}

export interface SharpProviderIncidentResponse {
    StatusCode: number;
    response: {
        entity: {
            result: string;
        };
        headers: {
            'strict-transport-security': string;
            'x-content-type-options': string;
            'server-timing': string;
            'x-is-logged-in': string;
            connection: string;
            'set-cookie': string;
            pragma: string;
            'transfer-encoding': string;
            'content-type': string;
            date: string;
            'cache-control': string;
            'x-transaction-id': string;
            server: string;
            expires: string;
        };
        statusLine: {
            protoVersion: string;
            statusCode: number;
            reasonPhrase: string;
        };
    };
}

export class UserInfo {
    public constructor(
        private gid: string,
        private email: string,
    ) {}
}

export class Attachment {
    public constructor(
        private payload: string,
        private fileName: string,
        private mime = 'text/plain',
    ) {}
}

export class SharpProviderIncidentPayload {
    public constructor(
        private externalID: string, // unique for each transaction
        private ci: SharpServiceNames,
        private priority: IncidentPriority,
        private shortDescription: string,
        private detailedDescription: string,
        private incidentType: IncidentType,
        private requester: UserInfo,
        private receiver: UserInfo,
        private attachment: Attachment[],
        private ticketStatus = 'New',
        private subCI = '',
        private subsubCI = '',
        private correlationSource = 'PAC_SL_INC_01',
        private contactType = 'Phone',
        private internalWorkNotes = '',
        private subcategory = '',
        private customerCommunication = '',
        private CorrelationTarget = 'SHARP_INC01',
    ) {}
}

export enum IncidentPriority {
    TOTALLY_BLOCKED = '2',
    PARTIALLY_BLOCKED = '3',
    NOT_BLOCKED = '4',
}

export enum IncidentType {
    FAILURE = 'Failure',
    REQUEST = 'Request',
}
